/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  "'Goals.CreateGoal.footer.create-label": 'Erstellen',
  'Goals.CreateGoal.create.error': 'Ziel konnte nicht erstellt werden',
  'Goals.CreateGoal.create.network.error': 'Verbindung konnte nicht hergestellt werden',
  'Goals.CreateGoal.create.permission.error':
    'Sie verfügen nicht über die erforderliche Berechtigung, um ein Ziel zu erstellen.',
  'Goals.CreateGoal.error.description':
    'Etwas ist schiefgelaufen. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
  'Goals.CreateGoal.error.header': 'Ziel konnte nicht erstellt werden',
  'Goals.CreateGoal.footer.cancel-label': 'Abbrechen',
  'Goals.CreateGoal.form.icon.back-button-label': 'Zurück',
  'Goals.CreateGoal.form.name.error': 'Sie müssen einen Zielnamen angeben.',
  'Goals.CreateGoal.form.name.label': 'Name',
  'Goals.CreateGoal.form.owner.error': '"Besitzer" darf nicht leer sein.',
  'Goals.CreateGoal.header': 'Ziel erstellen',
  'Goals.CreateGoal.parent-goal-label': 'Übergeordnetes Ziel',
  'Goals.CreateGoal.parent-goal.error': '"Übergeordnetes Ziel" darf nicht leer sein.',
  'Goals.CreateGoal.required-fields-are-marked':
    'Pflichtfelder sind mit einem Sternchen markiert.<asterisk></asterisk>',
  'Goals.CreateGoal.site-label': 'Site',
  'Goals.CreateGoal.type-label': 'Typ',
  'Goals.CreateGoal.type-label-placeholder': 'Wie soll es heißen?',
  'Goals.GoalCreationModal.label.date-selection-placeholder': 'Datum auswählen',
  'Goals.GoalCreationModal.label.date-selection-title': 'Zieldatum',
  'Goals.GoalCreationModal.label.owner-picker-placeholder': 'Person eingeben',
  'Goals.GoalCreationModal.label.owner-selection-title': 'Besitzer',
  'townsquare.api.goal-type-description.goal': 'Beliebige Ziele',
  'townsquare.api.goal-type-description.key-result':
    'Die quantitative Methode zur Messung einer Zielsetzung (OKR Framework)',
  'townsquare.api.goal-type-description.objective': 'Das Ergebnis, das Sie erreichen möchten (OKR Framework)',
};
